import {NgModule} from '@angular/core';
import {RbiDisclaimerComponent} from './rbi-disclaimer.component';

@NgModule({
    declarations: [RbiDisclaimerComponent],
    exports: [RbiDisclaimerComponent]
})
export class RbiDisclaimerModule {
}
